/* eslint-disable react/prop-types */
import {
  Checkbox,
  Typography,
  TextField,
  makeStyles,
  FormControlLabel,
  Grid,
} from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { classes as workerStyles } from "../AddWorkerStyles";
import React, { useEffect, useState } from "react";
import { getLocationForCountry } from "services/bulkUpload";
import { Controller, useFormContext } from "react-hook-form";
import { isEmptyObject } from "utils";
import { gdePermissionOpts } from "./utils";
import { useTranslation } from "react-i18next";
import { properCase } from "utils";
import { getWorkerGdeRole, getWorkerIMTimeRole} from "services/workerSchedule";




const useStyles = makeStyles((theme) => workerStyles(theme));


const GDEUserAccess = ({
  selectedWorker,
  manager,
  initialValue,
  setGdeValid,
  setIsWorkerGde,
}) => {
  const classes = useStyles();
  // const { control, handleSubmit } = useForm({
  //   defaultValues: initialGde,
  // });
  const { t, i18n } = useTranslation();
  console.log("initial gde", initialValue);
  const { control, setValue, getValues, errors, clearErrors } =
    useFormContext();
 
  const [countries,setCountries] = useState([]);
  const [ticked, setTicked] = useState(false);
  // const dataEntry = {t("other.lblDataEntry")};
  const [gdeRole, setgdeRole] = useState(null);

  const [gdeCountry,setGdeCountry]=useState([]);
  const [pinActive, setPinActive] = useState(false);
  const [gdePermissions, setGdePermissions] = useState([]);
  const [gdePermOptions, setGdePermOptions] = useState(gdePermissionOpts.filter(act => act.role === "Data Entry"));
  const [gdeRoles, setgdeRoles]=useState(["Data Entry", 
  "Supervisor", "Admin"]);
  const [loggedInWorkerGDERole, setLoggedInWorkerGDERole]=useState(null);
  const [loggedInWorkerIMTimeRole, setloggedInWorkerIMTimeRole] = useState(null);
  //for fetching districts, on creation as per user's country and alternate country
  //For editing worker, as per worker's country and alternate country
  useEffect(()=>{
    getWorkerIMTimeRole(manager?.workerId)
          .then((data) => {
            console.log("loggedIn worker imtRole", data);
            setloggedInWorkerIMTimeRole(data)
      });
    getWorkerGdeRole(manager?.workerId).then((data)=>{
      console.log("loggedIn worker gdeRole", data);
      setLoggedInWorkerGDERole(data);
    })
  },[])    
  useEffect(() => {
    selectedWorker
      ? getLocationForCountry(
        //selectedWorker.worker?.countryCode,
        //selectedWorker.worker?.alternateCountryCode
      ).then((data) => {
        const cleanData = [];
        data.forEach(item => {
         let buildings = item.buildings?item.buildings:{};
          if(buildings && Object.keys(buildings).length >0){
            Object.keys(buildings).forEach(building =>{
              if(buildings[building].activityEnabled && buildings[building].country){
                if(!cleanData.includes(buildings[building].country)){
                  cleanData.push(buildings[building].country);
                }
              }
            })
          }
        });
      
        console.log("country",cleanData);
      
        setCountries(cleanData);
      })
      : getLocationForCountry(
        //manager?.countryCode,
        //manager?.alternateCountryCode
      ).then((data) => {
        const cleanData=[];
        data.forEach(item => {
          let buildings = item.buildings?item.buildings:{};
           if(buildings && Object.keys(buildings).length >0){
             Object.keys(buildings).forEach(building =>{
               if(buildings[building].activityEnabled && buildings[building].country){
                 if(!cleanData.includes(buildings[building].country)){
                   cleanData.push(buildings[building].country);
                 }
               }
             })
           }
         });
        console.log("country",cleanData);
        setCountries(cleanData);
      });
  }, []);

  useEffect(() => {
    if (!isEmptyObject(initialValue) && loggedInWorkerGDERole!=null) {
      setValue("gdeRole", initialValue.gdeRole);
      setValue("isActive", initialValue.isActive);
    
      setValue("gdeCountry", initialValue.country?initialValue.country:[]);
      if (initialValue.pinActive) {
        setValue("pinActive", initialValue.pinActive);
        setPinActive(initialValue.pinActive);
      }

      setTicked(initialValue?.isActive);
      setgdeRole(initialValue?.gdeRole);
   
      setGdeCountry(initialValue.country?initialValue.country:[]);
      if (initialValue.gdeRole) {
        let filPermissionOpts = gdePermissionOpts.filter(act => act.role === initialValue.gdeRole);
        setGdePermOptions(filPermissionOpts);
        if (filPermissionOpts.length > 0 && initialValue?.additionalPermissions) {
          let defSelected = filPermissionOpts.filter(ele => initialValue?.additionalPermissions.some(act => act.label === ele.label && act.enabled));
          setValue("gdePermissions", defSelected);
          setGdePermissions(defSelected);
        }
      }
    }
    if(loggedInWorkerGDERole!=null && loggedInWorkerIMTimeRole!=null){
      if(!isEmptyObject(loggedInWorkerGDERole) && !isEmptyObject(loggedInWorkerIMTimeRole)){
        if(loggedInWorkerGDERole?.gdeRole==='Super User' && loggedInWorkerIMTimeRole?.role === 'Admin'){
          let filteredRoles=[...gdeRoles,'Super User']
          setgdeRoles(filteredRoles)
        }
      }
    }
  }, [initialValue, loggedInWorkerGDERole, loggedInWorkerIMTimeRole]);
  
  if (getValues("isActive")) {
    if (  
      (getValues("gdeRole")?.length > 0 && getValues("gdeRole") != "Super User") 
       || (getValues("gdeRole")?.length>0 && getValues("gdeRole") === "Super User" && getValues("gdeCountry")?.length > 0 )
    )
      setGdeValid(true);
    else setGdeValid(false);
  } else {
    setGdeValid(true);
  }

  useEffect(() => {
    if (getValues("isActive") !== ticked) {
      setValue("isActive", ticked);
    }
  }, [getValues("isActive")]);

  const countryValidation = (values) => {
    console.log("countryValidation", !!values && values.length !== 0 && getValues("isActive"), values)
    return (!!values && values.length !== 0 && getValues("isActive"));
  }

  console.log("error", errors);

  useEffect(() => {
    if (getValues("isActive") === false) clearErrors();
  }, [getValues("isActive")]);

  return (
    <>
      <Typography
        variant="h6"
        gutterBottom
        className={`${classes.employeeId} ${classes.title}`}
      >
        {t("other.lblGDEUserAccess")}
      </Typography>
      <Grid container >
        <Grid item xs={6}>
          <FormControlLabel
            control={
              <Controller
                name="isActive"
                control={control}
                defaultValue={ticked}
                render={(props) => (
                  <>
                    <Checkbox
                      {...props}
                      checked={props.value}
                      onChange={(e) => {
                        setTicked(e.target.checked);
                        setIsWorkerGde(e.target.checked);
                        if (e.target.checked === false) {
                          setPinActive(false);
                          setValue("pinActive", false);
                        }

                        props.onChange(e.target.checked);
                      }}
                      color="primary"
                      style={{ paddingLeft: 0 }}
                      inputRef={props.ref}
                    />
                  </>
                )}
              />
            }
            label={t("other.lblEnableGdeAccess")}
          />
        </Grid>
        <Grid item xs={6}>
          <FormControlLabel
            control={
              <Controller
                name="pinActive"
                control={control}
                defaultValue={pinActive}
                disabled={!ticked}
                render={(props) => (
                  <>
                    <Checkbox
                      {...props}
                      checked={props.value}
                      disabled={!ticked}
                      onChange={(e) => {
                        setPinActive(e.target.checked && ticked);
                        props.onChange(e.target.checked && ticked);
                      }}
                      color="primary"
                      style={{ paddingLeft: 0 }}
                      inputRef={props.ref}
                    />
                  </>
                )}
              />
            }
            label={t("other.lblPinUser")}
          />
        </Grid>
      </Grid>
      

      <Controller
        name="gdeRole"
        control={control}
        defaultValue={gdeRole}
        disabled={!ticked}
        rules={ticked ? { required: "Role cannot be blank" } : false}
        render={(props) => (
          <Autocomplete
            size="small"
            style={{ marginTop: 20, marginBottom: 20 }}
            options={gdeRoles}
            value={props.value}
            disableClearable
            disabled={!ticked}
            renderInput={(params) => (
              <TextField
                {...params}
                // {...props}
                style={{ maxWidth: 300 }}
                id="gdeRole"
                name="gdeRole"
                label={properCase(props.value ? t("other.lblRole") : t("other.lblSelectRole"))}
                required={getValues("isActive")}
                error={Boolean(errors.gdeRole)}
                helperText={errors.gdeRole?.message}
              />
            )}
            onChange={(e, val) => {
              props.onChange(val);
              if (val) {
                let filPermissionOpts = gdePermissionOpts.filter(act => act.role === val);
                setGdePermOptions(filPermissionOpts);
              } else {
                setGdePermOptions([]);
              }
              setValue('gdePermissions', []);
              setGdeCountry([]);
              setValue('gdeCountry',[])
            }}
          />
        )}
      />
        <Controller
        name="gdeCountry"
        control={control}
        defaultValue={gdeCountry}
        disabled={!ticked || !getValues('gdeRole') || getValues('gdeRole') === "Data Entry" || getValues('gdeRole') === "Admin" || getValues('gdeRole') === "Supervisor"}
        rules={{ 
          validate: getValues("isActive") && getValues("gdeRole") === "Super User" ? countryValidation : true,
        }}
        render={(props) => (
          <Autocomplete
            size="small"
            multiple
            style={{ marginTop: 20, marginBottom: 20 }}
            options={countries || []}
            value={props.value}
            disableCloseOnSelect
            disabled={!ticked || !getValues('gdeRole') || getValues('gdeRole') === "Data Entry" || getValues('gdeRole') === "Admin" || getValues('gdeRole') === "Supervisor"}
            renderInput={(params) => (
              <TextField
                {...params}
                // {...props}
                style={{ maxWidth: 300 }}
                id="gdeCountry"
                name="gdeCountry"
                label={properCase(props.value && props.value.length > 0 ? t("other.tlCountry") : t("other.lblSelectCountry"))}
                required={getValues("isActive") && getValues('gdeRole') === "Super User"}
                error={Boolean(errors.gdeCountry)}
                helperText={
                  errors?.gdeCountry?.type === "validate"
                    ? "Country cannot be blank"
                    : ""
                }

              />
            )}
            onChange={(e, val) => {
              props.onChange(val);
            }}
          />
        )}
      /> 
      <Controller
        name="gdePermissions"
        control={control}
        defaultValue={gdePermissions}
        disabled={!ticked || !getValues('gdeRole') /* || getValues('gdeRole') === "Admin" || getValues('gdeRole') === "Super User"*/}
        render={(props) => (
          <Autocomplete
            multiple
            size="small"
            style={{ marginTop: 20, marginBottom: 20 }}
            options={gdePermOptions}
            disableCloseOnSelect
            getOptionLabel={(option) => option.label}
            disabled={!ticked || !getValues('gdeRole') /*|| getValues('gdeRole') === "Admin" || getValues('gdeRole') === "Super User"*/}
            value={props.value}
            renderInput={(params) => (
              <TextField
                {...params}
                // {...props}
                style={{ maxWidth: 300 }}
                id="gdePermissions"
                name="gdePermissions"
                label={properCase(props.value.length > 0 ? t("other.lblPermissions") : t("other.lblSelectPermissions"))}
                //required={getValues("isActive")}
                error={Boolean(errors?.gdePermissions)}
                helperText={errors.gdePermissions?.message}
              />
            )}
            onChange={(e, val) => {
              props.onChange(val);
            }}
          />
        )}
      />
    </>
  );
};

export default GDEUserAccess;
